// Validación client-side del formato + dígito verificador de un cupón.
//
// Espeja EXACTAMENTE el alfabeto y los pesos de libs/crypto/coupon-codes.ts
// (backend). El verificador es un checksum posicional ponderado mod 31
// (el alfabeto tiene 31 símbolos y 31 es primo → detecta el 100% de los
// errores de un carácter y de las transposiciones adyacentes). Es público a
// propósito: permite rechazar un código mal tipeado al instante, sin pegarle
// a nuestro backend.
//
// ⚠️ Si cambian el alfabeto o los pesos en el backend, hay que reflejarlo acá.

const COUPON_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
const CODE_RE = /^[2-9A-HJ-KM-NP-Z]{8}$/;
// Pesos por posición (0..7); la posición 7 es el verificador (peso 1).
const CHECK_WEIGHTS = [2, 3, 4, 5, 6, 7, 8, 1];
const MOD = 31;

/** Normaliza: trim, uppercase, quita espacios y guiones. null si no es 8 chars del alfabeto. */
export function normalizeCoupon(raw: string): string | null {
  const cleaned = raw.replace(/[\s-]/g, '').toUpperCase();
  return CODE_RE.test(cleaned) ? cleaned : null;
}

/** true si el dígito verificador del código (ya normalizado) cierra mod 31. */
export function hasValidCheckDigit(code: string): boolean {
  if (code.length !== 8) return false;
  let sum = 0;
  for (let i = 0; i < 8; i++) {
    const v = COUPON_ALPHABET.indexOf(code[i]!);
    if (v < 0) return false;
    sum += CHECK_WEIGHTS[i]! * v;
  }
  return sum % MOD === 0;
}

/**
 * Chequeo local completo antes de intentar el canje: formato + verificador.
 * Devuelve el código normalizado si es válido, o null si hay que mostrar
 * "Código no válido" sin llamar a la API.
 */
export function precheckCoupon(raw: string): string | null {
  const code = normalizeCoupon(raw);
  if (!code || !hasValidCheckDigit(code)) return null;
  return code;
}
